// Mock data for Works Module Reports

// 1. Work Order Execution & Progress Summary Data
export const WORK_ORDER_EXECUTION_DATA = [
  {
    id: 1,
    workOrderNo: "WO-2026-0045",
    project: "Gulberg Heights",
    subcontractor: "Haji Aslam & Sons (Masonry)",
    scope: "Tower A - 2nd to 5th Floor Brick Masonry",
    contractValue: 4850000,
    certifiedWorkMB: 3650000,
    billedToDate: 3200000,
    financialCompletion: 66.0,
    physicalCompletion: 75.3,
    unbilledProgress: 450000,
    status: "In Progress",
  },
  {
    id: 2,
    workOrderNo: "WO-2026-0048",
    project: "Blue Horizon Tower",
    subcontractor: "Al-Rehman Steel Fixers",
    scope: "Basement 2 & 1 Raft Steel Fixing",
    contractValue: 8400000,
    certifiedWorkMB: 8400000,
    billedToDate: 8400000,
    financialCompletion: 100.0,
    physicalCompletion: 100.0,
    unbilledProgress: 0,
    status: "Completed",
  },
  {
    id: 3,
    workOrderNo: "WO-2026-0052",
    project: "Gulberg Heights",
    subcontractor: "Malik Shuttering & Scaffolding",
    scope: "Tower B - Formwork & Falsework Level 1-4",
    contractValue: 6200000,
    certifiedWorkMB: 4900000,
    billedToDate: 4100000,
    financialCompletion: 66.1,
    physicalCompletion: 79.0,
    unbilledProgress: 800000,
    status: "In Progress",
  },
  {
    id: 4,
    workOrderNo: "WO-2026-0056",
    project: "Metro Bus Extension",
    subcontractor: "Chaudhry Piling & Foundations",
    scope: "Piers 12 to 24 Cast-in-situ Bored Piles",
    contractValue: 14500000,
    certifiedWorkMB: 11200000,
    billedToDate: 9800000,
    financialCompletion: 67.6,
    physicalCompletion: 77.2,
    unbilledProgress: 1400000,
    status: "In Progress",
  },
  {
    id: 5,
    workOrderNo: "WO-2026-0060",
    project: "Grand Avenue Residency",
    subcontractor: "Bismillah Electrical Contractors",
    scope: "Block C - Conduit Piping & Electrical Grounding",
    contractValue: 3100000,
    certifiedWorkMB: 1200000,
    billedToDate: 800000,
    financialCompletion: 25.8,
    physicalCompletion: 38.7,
    unbilledProgress: 400000,
    status: "In Progress",
  },
  {
    id: 6,
    workOrderNo: "WO-2026-0063",
    project: "Defense Raya Club",
    subcontractor: "Tariq Plaster & Finishing Works",
    scope: "Sports Complex Internal & External Cement Plaster",
    contractValue: 5400000,
    certifiedWorkMB: 5400000,
    billedToDate: 5100000,
    financialCompletion: 94.4,
    physicalCompletion: 100.0,
    unbilledProgress: 300000,
    status: "Punch List / Handover",
  },
  {
    id: 7,
    workOrderNo: "WO-2026-0067",
    project: "Blue Horizon Tower",
    subcontractor: "Raza HVAC & Firefighting Services",
    scope: "Core Shaft Chilled Water & Sprinkler Risers",
    contractValue: 7900000,
    certifiedWorkMB: 2800000,
    billedToDate: 2100000,
    financialCompletion: 26.6,
    physicalCompletion: 35.4,
    unbilledProgress: 700000,
    status: "In Progress",
  },
  {
    id: 8,
    workOrderNo: "WO-2026-0071",
    project: "Bahria Enclave Sector B",
    subcontractor: "Naveed Flooring & Marble Works",
    scope: "Commercial Plaza Italian Marble Laying",
    contractValue: 4200000,
    certifiedWorkMB: 650000,
    billedToDate: 0,
    financialCompletion: 0.0,
    physicalCompletion: 15.5,
    unbilledProgress: 650000,
    status: "Just Started",
  },
];

// 2. Subcontractor-Wise RA Bill Register (Bill-by-Bill Audit) Data
export const RA_BILL_REGISTER_DATA = [
  {
    id: 1,
    billNo: "RAB-2026-0098",
    submissionDate: "2026-10-04",
    workOrderRef: "WO-2026-0045",
    contractorName: "Haji Aslam & Sons (Masonry)",
    grossCertified: 950000,
    retentionWithheld: 47500, // 5%
    mobilizationRecovery: 95000, // 10%
    whtDeducted: 71250, // 7.5%
    materialDeductions: 12000,
    netPayable: 724250,
    status: "Paid / Settled",
  },
  {
    id: 2,
    billNo: "RAB-2026-0102",
    submissionDate: "2026-10-08",
    workOrderRef: "WO-2026-0052",
    contractorName: "Malik Shuttering & Scaffolding",
    grossCertified: 1400000,
    retentionWithheld: 70000, // 5%
    mobilizationRecovery: 140000,
    whtDeducted: 105000,
    materialDeductions: 25000,
    netPayable: 1060000,
    status: "Approved",
  },
  {
    id: 3,
    billNo: "RAB-2026-0105",
    submissionDate: "2026-10-12",
    workOrderRef: "WO-2026-0056",
    contractorName: "Chaudhry Piling & Foundations",
    grossCertified: 2800000,
    retentionWithheld: 140000,
    mobilizationRecovery: 280000,
    whtDeducted: 210000,
    materialDeductions: 45000,
    netPayable: 2125000,
    status: "Approved",
  },
  {
    id: 4,
    billNo: "RAB-2026-0109",
    submissionDate: "2026-10-15",
    workOrderRef: "WO-2026-0060",
    contractorName: "Bismillah Electrical Contractors",
    grossCertified: 800000,
    retentionWithheld: 40000,
    mobilizationRecovery: 80000,
    whtDeducted: 60000,
    materialDeductions: 0,
    netPayable: 620000,
    status: "Under Review",
  },
  {
    id: 5,
    billNo: "RAB-2026-0112",
    submissionDate: "2026-10-17",
    workOrderRef: "WO-2026-0063",
    contractorName: "Tariq Plaster & Finishing Works",
    grossCertified: 1650000,
    retentionWithheld: 82500,
    mobilizationRecovery: 0, // fully recovered
    whtDeducted: 123750,
    materialDeductions: 18500,
    netPayable: 1425250,
    status: "Approved",
  },
  {
    id: 6,
    billNo: "RAB-2026-0115",
    submissionDate: "2026-10-19",
    workOrderRef: "WO-2026-0067",
    contractorName: "Raza HVAC & Firefighting Services",
    grossCertified: 1100000,
    retentionWithheld: 55000,
    mobilizationRecovery: 110000,
    whtDeducted: 82500,
    materialDeductions: 8000,
    netPayable: 844500,
    status: "Under Review",
  },
  {
    id: 7,
    billNo: "RAB-2026-0118",
    submissionDate: "2026-10-21",
    workOrderRef: "WO-2026-0048",
    contractorName: "Al-Rehman Steel Fixers",
    grossCertified: 1850000,
    retentionWithheld: 92500,
    mobilizationRecovery: 0,
    whtDeducted: 138750,
    materialDeductions: 0,
    netPayable: 1618750,
    status: "Draft",
  },
  {
    id: 8,
    billNo: "RAB-2026-0120",
    submissionDate: "2026-10-22",
    workOrderRef: "WO-2026-0045",
    contractorName: "Haji Aslam & Sons (Masonry)",
    grossCertified: 1250000,
    retentionWithheld: 62500,
    mobilizationRecovery: 125000,
    whtDeducted: 93750,
    materialDeductions: 15000,
    netPayable: 953750,
    status: "Draft",
  },
];

// 3. Measurement Book (MB) Quantity Audit Register Data
export const MB_AUDIT_REGISTER_DATA = [
  {
    id: 1,
    mbRecordNo: "MB-2026-0114",
    dateRecorded: "2026-10-06",
    workOrderNo: "WO-2026-0045",
    boqItem: 'BOQ-CIV-003: 9" Thick Brickwork in 1:4 Mortar',
    subLocation: "Tower A - 2nd Floor, Grid C4-C8",
    dimensions: "L: 45.0m × B: 0.23m × H: 3.2m",
    qtyThisEntry: 33.1,
    cumulativeQty: 485.5,
    woLimit: 650.0,
    status: "Within Limit",
    recordedBy: "Engr. Salman Raza (Site Engr)",
    verifiedBy: "Engr. Tariq Mehmood (RE)",
  },
  {
    id: 2,
    mbRecordNo: "MB-2026-0118",
    dateRecorded: "2026-10-09",
    workOrderNo: "WO-2026-0048",
    boqItem: "BOQ-CIV-008: Deformed Steel Rebar Grade 60 Cut & Bend",
    subLocation: "Basement 1 - Retaining Wall Steel",
    dimensions: "Steel Bar Bending Schedule (Weight in MT)",
    qtyThisEntry: 14.2,
    cumulativeQty: 84.0,
    woLimit: 84.0,
    status: "Within Limit",
    recordedBy: "Engr. Hamza Farooq (Site Engr)",
    verifiedBy: "Engr. Tariq Mehmood (RE)",
  },
  {
    id: 3,
    mbRecordNo: "MB-2026-0122",
    dateRecorded: "2026-10-12",
    workOrderNo: "WO-2026-0052",
    boqItem: "BOQ-CIV-012: Formwork to Vertical Concrete Surfaces",
    subLocation: "Tower B - Level 3 Shear Walls",
    dimensions: "L: 28.5m × H: 3.4m × 2 sides",
    qtyThisEntry: 193.8,
    cumulativeQty: 1820.0,
    woLimit: 1750.0,
    status: "Limit Exceeded Alert",
    recordedBy: "Engr. Waqas Bilal (Site Engr)",
    verifiedBy: "Engr. Tariq Mehmood (RE)",
  },
  {
    id: 4,
    mbRecordNo: "MB-2026-0125",
    dateRecorded: "2026-10-14",
    workOrderNo: "WO-2026-0056",
    boqItem: "BOQ-STR-001: 760mm Dia Bored Cast-in-situ Piles",
    subLocation: "Pier 18 to 20 - North Abutment",
    dimensions: "8 Piles × 22.5m Depth = 180 Rft",
    qtyThisEntry: 180.0,
    cumulativeQty: 1260.0,
    woLimit: 1500.0,
    status: "Within Limit",
    recordedBy: "Engr. Danish Niaz (Site Engr)",
    verifiedBy: "Engr. Kamran Akram (PM)",
  },
  {
    id: 5,
    mbRecordNo: "MB-2026-0129",
    dateRecorded: "2026-10-16",
    workOrderNo: "WO-2026-0060",
    boqItem: "BOQ-ELE-004: 25mm Heavy Gauge PVC Conduit Embedded",
    subLocation: "Block C - Ground Floor Apartment Corridors",
    dimensions: "Linear Run Measure across 12 Units",
    qtyThisEntry: 450.0,
    cumulativeQty: 1250.0,
    woLimit: 3200.0,
    status: "Within Limit",
    recordedBy: "Engr. Asif Javed (MEP Engr)",
    verifiedBy: "Engr. Kamran Akram (PM)",
  },
  {
    id: 6,
    mbRecordNo: "MB-2026-0133",
    dateRecorded: "2026-10-18",
    workOrderNo: "WO-2026-0063",
    boqItem: "BOQ-FIN-002: 1:4 Cement Sand Internal Plaster 12mm",
    subLocation: "Sports Complex - Squash Court Walls",
    dimensions: "L: 38.0m × H: 5.8m × 4 courts",
    qtyThisEntry: 881.6,
    cumulativeQty: 5420.0,
    woLimit: 5200.0,
    status: "Limit Exceeded Alert",
    recordedBy: "Engr. Salman Raza (Site Engr)",
    verifiedBy: "Engr. Tariq Mehmood (RE)",
  },
  {
    id: 7,
    mbRecordNo: "MB-2026-0137",
    dateRecorded: "2026-10-20",
    workOrderNo: "WO-2026-0067",
    boqItem: "BOQ-MEC-005: 100mm Dia Black Steel Fire Sprinkler Pipe",
    subLocation: "Tower A & B - Podium Ceiling Riser",
    dimensions: "Joint to Joint Measured Length = 120m",
    qtyThisEntry: 120.0,
    cumulativeQty: 580.0,
    woLimit: 950.0,
    status: "Within Limit",
    recordedBy: "Engr. Asif Javed (MEP Engr)",
    verifiedBy: "Engr. Kamran Akram (PM)",
  },
  {
    id: 8,
    mbRecordNo: "MB-2026-0140",
    dateRecorded: "2026-10-22",
    workOrderNo: "WO-2026-0071",
    boqItem: 'BOQ-FIN-009: Botticino Marble Flooring 12"×12"',
    subLocation: "Commercial Plaza - Atrium Reception Lobby",
    dimensions: "L: 24.0m × B: 15.0m Area = 360 m²",
    qtyThisEntry: 360.0,
    cumulativeQty: 360.0,
    woLimit: 1400.0,
    status: "Within Limit",
    recordedBy: "Engr. Waqas Bilal (Site Engr)",
    verifiedBy: "Engr. Tariq Mehmood (RE)",
  },
];

// 4. Subcontractor Retention Money Ledger Data
export const RETENTION_LEDGER_DATA = [
  {
    id: 1,
    subcontractor: "Al-Rehman Steel Fixers",
    workOrderRef: "WO-2026-0048",
    project: "Blue Horizon Tower",
    contractValue: 8400000,
    retentionWithheld: 420000, // 5%
    retentionReleased: 210000, // 50% released at practical completion
    netRetentionBalance: 210000,
    completionDate: "2026-09-30",
    targetReleaseDate: "2027-03-30", // 6 months DLP
  },
  {
    id: 2,
    subcontractor: "Tariq Plaster & Finishing Works",
    workOrderRef: "WO-2026-0063",
    project: "Defense Raya Club",
    contractValue: 5400000,
    retentionWithheld: 270000,
    retentionReleased: 0,
    netRetentionBalance: 270000,
    completionDate: "2026-10-15",
    targetReleaseDate: "2027-04-15",
  },
  {
    id: 3,
    subcontractor: "Haji Aslam & Sons (Masonry)",
    workOrderRef: "WO-2026-0045",
    project: "Gulberg Heights",
    contractValue: 4850000,
    retentionWithheld: 160000,
    retentionReleased: 0,
    netRetentionBalance: 160000,
    completionDate: "In Progress",
    targetReleaseDate: "2027-06-30",
  },
  {
    id: 4,
    subcontractor: "Malik Shuttering & Scaffolding",
    workOrderRef: "WO-2026-0052",
    project: "Gulberg Heights",
    contractValue: 6200000,
    retentionWithheld: 205000,
    retentionReleased: 0,
    netRetentionBalance: 205000,
    completionDate: "In Progress",
    targetReleaseDate: "2027-08-15",
  },
  {
    id: 5,
    subcontractor: "Chaudhry Piling & Foundations",
    workOrderRef: "WO-2026-0056",
    project: "Metro Bus Extension",
    contractValue: 14500000,
    retentionWithheld: 490000,
    retentionReleased: 0,
    netRetentionBalance: 490000,
    completionDate: "In Progress",
    targetReleaseDate: "2027-05-30",
  },
  {
    id: 6,
    subcontractor: "Bismillah Electrical Contractors",
    workOrderRef: "WO-2026-0060",
    project: "Grand Avenue Residency",
    contractValue: 3100000,
    retentionWithheld: 40000,
    retentionReleased: 0,
    netRetentionBalance: 40000,
    completionDate: "In Progress",
    targetReleaseDate: "2027-09-30",
  },
  {
    id: 7,
    subcontractor: "Raza HVAC & Firefighting Services",
    workOrderRef: "WO-2026-0067",
    project: "Blue Horizon Tower",
    contractValue: 7900000,
    retentionWithheld: 105000,
    retentionReleased: 0,
    netRetentionBalance: 105000,
    completionDate: "In Progress",
    targetReleaseDate: "2027-11-15",
  },
  {
    id: 8,
    subcontractor: "Naveed Flooring & Marble Works",
    workOrderRef: "WO-2026-0071",
    project: "Bahria Enclave Sector B",
    contractValue: 4200000,
    retentionWithheld: 0,
    retentionReleased: 0,
    netRetentionBalance: 0,
    completionDate: "In Progress",
    targetReleaseDate: "2027-12-31",
  },
];

// 5. Mobilization & Material Advance Recovery Statement Data
export const ADVANCE_RECOVERY_DATA = [
  {
    id: 1,
    contractorName: "Haji Aslam & Sons (Masonry)",
    workOrderNo: "WO-2026-0045",
    workOrderDate: "2026-08-10",
    initialMobAdvance: 485000, // 10%
    materialAdvance: 150000,
    totalDisbursed: 635000,
    cumulativeRecovery: 320000,
    outstandingBalance: 315000,
    recoveryStatus: "On Track",
  },
  {
    id: 2,
    contractorName: "Al-Rehman Steel Fixers",
    workOrderNo: "WO-2026-0048",
    workOrderDate: "2026-07-15",
    initialMobAdvance: 840000,
    materialAdvance: 0,
    totalDisbursed: 840000,
    cumulativeRecovery: 840000,
    outstandingBalance: 0,
    recoveryStatus: "Fully Recovered",
  },
  {
    id: 3,
    contractorName: "Malik Shuttering & Scaffolding",
    workOrderNo: "WO-2026-0052",
    workOrderDate: "2026-08-20",
    initialMobAdvance: 620000,
    materialAdvance: 200000,
    totalDisbursed: 820000,
    cumulativeRecovery: 410000,
    outstandingBalance: 410000,
    recoveryStatus: "On Track",
  },
  {
    id: 4,
    contractorName: "Chaudhry Piling & Foundations",
    workOrderNo: "WO-2026-0056",
    workOrderDate: "2026-09-01",
    initialMobAdvance: 1450000,
    materialAdvance: 500000,
    totalDisbursed: 1950000,
    cumulativeRecovery: 980000,
    outstandingBalance: 970000,
    recoveryStatus: "On Track",
  },
  {
    id: 5,
    contractorName: "Bismillah Electrical Contractors",
    workOrderNo: "WO-2026-0060",
    workOrderDate: "2026-09-12",
    initialMobAdvance: 310000,
    materialAdvance: 80000,
    totalDisbursed: 390000,
    cumulativeRecovery: 80000,
    outstandingBalance: 310000,
    recoveryStatus: "Delayed / Risk Alert",
  },
  {
    id: 6,
    contractorName: "Tariq Plaster & Finishing Works",
    workOrderNo: "WO-2026-0063",
    workOrderDate: "2026-08-05",
    initialMobAdvance: 540000,
    materialAdvance: 0,
    totalDisbursed: 540000,
    cumulativeRecovery: 540000,
    outstandingBalance: 0,
    recoveryStatus: "Fully Recovered",
  },
  {
    id: 7,
    contractorName: "Raza HVAC & Firefighting Services",
    workOrderNo: "WO-2026-0067",
    workOrderDate: "2026-09-18",
    initialMobAdvance: 790000,
    materialAdvance: 250000,
    totalDisbursed: 1040000,
    cumulativeRecovery: 210000,
    outstandingBalance: 830000,
    recoveryStatus: "Delayed / Risk Alert",
  },
  {
    id: 8,
    contractorName: "Naveed Flooring & Marble Works",
    workOrderNo: "WO-2026-0071",
    workOrderDate: "2026-10-02",
    initialMobAdvance: 420000,
    materialAdvance: 100000,
    totalDisbursed: 520000,
    cumulativeRecovery: 0,
    outstandingBalance: 520000,
    recoveryStatus: "On Track",
  },
];

// 6. Subcontractor Payables Aging & Clearance Schedule Data
export const CONTRACTOR_AGING_DATA = [
  {
    id: 1,
    contractorName: "Malik Shuttering & Scaffolding",
    leadTrade: "Formwork & Falsework",
    approvedBillNo: "RAB-2026-0102",
    certifiedDate: "2026-10-18",
    netPayable: 1060000,
    agingCategory: "0 – 7 Days",
    paymentMode: "HBL Corporate Cheque #491204",
  },
  {
    id: 2,
    contractorName: "Chaudhry Piling & Foundations",
    leadTrade: "Piling & Geotechnical",
    approvedBillNo: "RAB-2026-0105",
    certifiedDate: "2026-10-14",
    netPayable: 2125000,
    agingCategory: "8 – 15 Days",
    paymentMode: "Bank Alfalah Pay Order",
  },
  {
    id: 3,
    contractorName: "Tariq Plaster & Finishing Works",
    leadTrade: "Plaster & External Finish",
    approvedBillNo: "RAB-2026-0112",
    certifiedDate: "2026-10-10",
    netPayable: 1425250,
    agingCategory: "8 – 15 Days",
    paymentMode: "Meezan Bank IBFT Direct",
  },
  {
    id: 4,
    contractorName: "Bismillah Electrical Contractors",
    leadTrade: "Electrical & Low Voltage",
    approvedBillNo: "RAB-2026-0089",
    certifiedDate: "2026-09-28",
    netPayable: 620000,
    agingCategory: "16 – 30 Days",
    paymentMode: "HBL Cheque",
  },
  {
    id: 5,
    contractorName: "Raza HVAC & Firefighting Services",
    leadTrade: "MEP & Fire Protection",
    approvedBillNo: "RAB-2026-0091",
    certifiedDate: "2026-09-24",
    netPayable: 844500,
    agingCategory: "16 – 30 Days",
    paymentMode: "Bank Al Habib Cheque",
  },
  {
    id: 6,
    contractorName: "Haji Aslam & Sons (Masonry)",
    leadTrade: "Brick Masonry & Blockwork",
    approvedBillNo: "RAB-2026-0078",
    certifiedDate: "2026-09-15",
    netPayable: 724250,
    agingCategory: "Over 30 Days",
    paymentMode: "MCB Corporate Transfer",
  },
  {
    id: 7,
    contractorName: "Al-Rehman Steel Fixers",
    leadTrade: "Reinforcement Steel Fixing",
    approvedBillNo: "RAB-2026-0065",
    certifiedDate: "2026-09-08",
    netPayable: 950000,
    agingCategory: "Over 30 Days",
    paymentMode: "Allied Bank Crossed Cheque",
  },
  {
    id: 8,
    contractorName: "Naveed Flooring & Marble Works",
    leadTrade: "Flooring & Marble Tiling",
    approvedBillNo: "RAB-2026-0125",
    certifiedDate: "2026-10-21",
    netPayable: 450000,
    agingCategory: "0 – 7 Days",
    paymentMode: "Pending Cheque Issuance",
  },
];
